import Image from 'next/image'
import profile from 'public/images/profile.png'
import StarRating from '@/components/starraing-new'

const ReviewCard = ({
  author,
  title,
  content,
  rating,
}: {
  author: string
  content: string
  title: string
  rating: number
}) => {
  return (
    <div className='bg-[#FBFBFBC4] gap-7 rounded-[27px] p-6 w-full h-[400px] relative text-center overflow-hidden'>
      <div className='w-full flex flex-col gap-1.5 justify-center items-center'>
        <Image
          src={profile}
          alt='leftQuote'
          className='rounded-full w-[71px] h-[71px]'
        />
        <p className='text-[14px] font-medium text-[#0F0B24] text-right'>
          {author}
        </p>
        <p className='text-[14px] font-medium text-[#5A5667] text-right'>
          {title}
        </p>
      </div>

      <p className='text-[#353247] text-[15px] font-medium leading-relaxed pt-2 text-center overflow-hidden'>
        {content}
      </p>
      <div className='mt-4 flex justify-center items-center'>
        {/* <Image src={Stars} alt='leftQuote' className='' /> */}
        <StarRating
          rating={rating}
          className='items-center'
          IconClassName='text-[#FFA125] text-[20px] align-middle'
          size={20}
        />
      </div>
    </div>
  )
}

export default ReviewCard
